<div class="ant-input-number-handler-wrap">
  <span
    class="ant-input-number-handler ant-input-number-handler-up"
    #upHandler
    [class.ant-input-number-handler-up-disabled]="disabledUp"
    (mousedown)="up($event)"
    (mouseup)="stop()"
    (mouseleave)="stop()"
    unselectable="unselectable">
    <ui-icon uiType="chevron-up-small" uiTheme="outline"></ui-icon>
  </span>
  <span
    class="ant-input-number-handler ant-input-number-handler-down"
    #downHandler
    [class.ant-input-number-handler-down-disabled]="disabledDown"
    (mousedown)="down($event)"
    (mouseup)="stop()"
    (mouseleave)="stop()"
    unselectable="unselectable">
    <ui-icon uiType="chevron-down-small" uiTheme="outline"></ui-icon>
  </span>
</div>
<div class="ant-input-number-input-wrap">
  <input
    class="ant-input-number-input"
    #inputElement
    [ngModel]="displayValue"
    [attr.id]="nzId"
    [attr.autofocus]="nzAutoFocus ? 'autofocus' : null"
    [disabled]="nzDisabled"
    [attr.min]="nzMin"
    [attr.max]="nzMax"
    [placeholder]="nzPlaceHolder"
    [attr.step]="nzStep"
    [attr.inputmode]="nzInputMode"
    [attr.aria-label]="a11yLabel"
    [attr.aria-labelledby]="a11yLabelledby"
    [attr.aria-describedby]="a11yDescribedby"
    [attr.aria-required]="a11yRequired"
    [attr.aria-disabled]="a11yDisabled"
    [attr.aria-errormessage]="errorMessageId"
    [attr.data-test-id]="e2eTestId"
    (input)="forbidAlphabeticValue($any($event))"
    (keyup)="stop()"
    (ngModelChange)="onModelChange($event)"
    (focus)="onFocus()"
    type="text"
    autocomplete="off" />
</div>
